import { DeviceType } from './device';

// Логи, доступные для всех типов устройств
const BASE_LOG_ROUTES = ['device-info', 'kafka-to-clickhouse', 'packet-controller'];

// Дополнительные логи для конкретных типов устройств
const ADDITIONAL_LOG_ROUTES: Partial<Record<DeviceType, string[]>> = {
    [DeviceType.Device_TKLLog_NBIOT]: ['nidd-receiver'],
    [DeviceType.Device_TKLLog_LORAWAN]: ['lorawan-receiver'],
};

/**
 * Пути сервисов логов, доступные для указанного типа устройства.
 *
 * @param {DeviceType} deviceType тип устройства
 * @returns {string[]} пути сервисов логов
 */
export function deviceLogRoutes(deviceType: DeviceType): string[] {
    return [...BASE_LOG_ROUTES, ...(ADDITIONAL_LOG_ROUTES[deviceType] ?? [])];
}
